import { enUS, fr } from 'date-fns/locale'
import { AvailableLanguages } from '../../types/language.types'
import { Locale } from 'date-fns'

const localeMapping: Record<AvailableLanguages, Locale> = {
  fr: fr,
  en: enUS
}

export const getLocale = (currentLanguage: AvailableLanguages) => localeMapping[currentLanguage]
